import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Locations from "@/pages/Locations";

export const Route = createFileRoute("/_public/locations/")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Service Areas \u2014 Non-Electric Fence Installer", "Explore dog, deer and garden fence planning by region and town. Nationwide installation is subject to project scope and configured state requirements.", "/locations", false),
  component: Locations,
});
